import React from 'react';
import './HelpSidebar.css';

export interface HelpTocItem {
  id: string;
  label: string;
}

interface HelpSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  content: React.ReactNode;
  toc?: HelpTocItem[];
  tours?: React.ReactNode;
}

export default function HelpSidebar({ isOpen, onClose, content, toc, tours }: HelpSidebarProps) {
  const scrollToAnchor = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <div className={`help-sidebar-overlay ${isOpen ? 'open' : ''}`} onClick={onClose} />
      <aside className={`help-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="help-sidebar-header">
          <h3>Help & User Guide</h3>
          <button className="help-sidebar-close" onClick={onClose} aria-label="Close help">
            ×
          </button>
        </div>
        <div className="help-sidebar-content">
          {toc && toc.length > 0 && (
            <nav className="help-sidebar-toc" aria-label="Table of contents">
              <div className="help-sidebar-toc-title">On this page</div>
              <ul>
                {toc.map((item) => (
                  <li key={item.id}>
                    <button type="button" onClick={() => scrollToAnchor(item.id)}>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
          <div className="help-sidebar-guide">{content}</div>
          {tours}
        </div>
      </aside>
    </>
  );
}
